import LogoCheckbox from './logoCheckbox.view';

export default LogoCheckbox;
